import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { history } from "../../_helpers";
import authService from "../../_services/cart/authService";
import { FormDatosUsuario } from "../perfil/FormDatosUsuario";
import { PanelSeguridad } from "../perfil/PanelSeguridad";
import { NavBarLateral } from "../vendedor/NavBarLateral";

/**
 * Perfil de la cuenta de administracion.
 *
 * Existe porque el link "Mi perfil" del menu lateral solo tenia dos destinos:
 * el del vendedor o el del comprador. Un admin que no es vendedor caia en el
 * de comprador, que habla de compras y no dice nada de su cuenta ni de sus
 * permisos. Los datos personales son los mismos (FormDatosUsuario); lo propio
 * de esta pantalla es el resumen de la cuenta y sus roles.
 */
class MiPerfilAdmin extends React.Component {
  handleClose = () => {};

  render() {
    // Mismo guard que el resto de /admin.
    if (!authService.hasAuthority("ADMIN")) {
      history.push("/");
    }

    const user = authService.getLoggedUser();
    const esVendedor = authService.hasAuthority("VENDEDOR");
    const roles = user?.roles || [];

    return (
      <div className="dashboard">
        <NavBarLateral handleClose={this.handleClose} />
        <div className="dashboard__content">
          <div className="dashboard__content-header">
            <div className="dashboard__content-title">
              <h2>Mi perfil</h2>
            </div>
          </div>
          <div className="dashboard__content-subheader">
            <h3 className="small">
              Tu cuenta de administración: datos personales, contraseña y
              permisos.
            </h3>
          </div>

          {/*
            Las mismas solapas que el perfil del vendedor: ubicación aparte, y cobros
            sólo si este admin además vende (es el caso de quien administra su propio
            desarmadero). Un solo formulario: "Grabar cambios" guarda todas.
          */}
          <FormDatosUsuario
            className="bg-iot"
            accion="actualizar"
            esVendedor={esVendedor}
          >
            {({ secciones, botonGrabar }) => (
          <Tabs id="perfil-admin-tabs" defaultActiveKey="datos" mountOnEnter>
            <Tab eventKey="datos" title="Mis datos">
              <div className="perfil__panel">
                {secciones.datosUsuario}
                {secciones.perfil}
                {secciones.redes}
                {secciones.imagenes}
                {botonGrabar}
              </div>
            </Tab>

            {secciones.pago && (
              <Tab eventKey="cobros" title="Cobros">
                <div className="perfil__panel">
                  {secciones.pago}
                  {botonGrabar}
                </div>
              </Tab>
            )}

            <Tab eventKey="ubicacion" title="Ubicación">
              <div className="perfil__panel">
                {secciones.ubicacion}
                {botonGrabar}
              </div>
            </Tab>

            <Tab eventKey="seguridad" title="Seguridad">
              <div className="perfil__panel">
                <PanelSeguridad />
              </div>
            </Tab>

            <Tab eventKey="cuenta" title="Cuenta">
              <div className="perfil__panel">
                <h4>Permisos</h4>
                <div className="dashboard__content-prod">
                  <div className="dashboard__profile">
                    <div className="dashboard__profile-icon">
                      <FontAwesomeIcon
                        icon="fa-solid fa-user-shield"
                        size="4x"
                      />
                      <span className="perfil-admin__cuenta">
                        {user?.email}
                        {roles.length > 0 && (
                          <span className="perfil-admin__roles">
                            {roles.map((rol) => (
                              <span className="perfil-admin__rol" key={rol}>
                                {rol}
                              </span>
                            ))}
                          </span>
                        )}
                      </span>
                    </div>
                    <button
                      className="button"
                      data-type="complementary"
                      type="button"
                      onClick={() => history.push("/admin/usuarios")}
                    >
                      Ver usuarios
                    </button>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
            )}
          </FormDatosUsuario>
        </div>
      </div>
    );
  }
}

export { MiPerfilAdmin };
